const fieldsBannerConfig = [
  {
    field: 'competition_day',
    title: 'День',
    width: '5%',
  },
  {
    field: 'competition_date',
    title: 'Дата',
    width: '10%',
  },
  {
    field: 'place',
    title: 'Место',
    width: '5%',
  },
  {
    field: 'purchase_amount',
    title: 'Сумма покупки',
    width: '10%',
  },
  {
    field: 'purchase_amount_today',
    title: 'Покупок сегодня',
    width: '10%',
  },
];

export { fieldsBannerConfig };
